import React from 'react'
import "./B2Page.css"
import B2CourseDetails from './B2CourseDetails'

const B2Main = () => {
  return (
    <div className='b2PageMainContainer'>
      <B2CourseDetails/>
    </div>
  )
}

export default B2Main
